export const StaryyaDarohi = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [28.53960073931006, 53.099859475256835],
            [28.540437676557588, 53.103377039818554],
            [28.532052884333268, 53.11008852196784],
            [28.525065556730226, 53.11512144559839],
            [28.518078229127127, 53.127701178566554],
            [28.518078229127127, 53.140277230609684],
            [28.511090902423234, 53.15201155768739],
            [28.494321316175956, 53.153687627781835],
            [28.470564402325408, 53.152849600828574],
            [28.45658974711921, 53.14782109466796],
            [28.44680748937418, 53.14446842927464],
            [28.427242972984857, 53.14195375845924],
            [28.40767845569627, 53.14614479434681],
            [28.40208859361377, 53.15117349745901],
            [28.39510126601067, 53.15117349745901],
            [28.375536748722084, 53.14614479434681],
            [28.36715195649765, 53.14530661990477],
            [28.35457476681222, 53.152849600828574],
            [28.35876716337401, 53.1612291365156],
            [28.361562094415092, 53.16793158767268],
            [28.361562094415092, 53.172120088371514],
            [28.35876716337401, 53.18468313711713],
            [28.34758743920912, 53.19138192533569],
            [28.33361278490213, 53.194730926890884],
            [28.31824066417539, 53.19891681056254],
            [28.309855871051752, 53.19891681056254],
            [28.308458406430418, 53.189707325632696],
            [28.308458406430418, 53.18300827571147],
            [28.29727868226547, 53.176308179878674],
            [28.2805090969174, 53.177983302087796],
            [28.27491923483501, 53.18468313711713],
            [28.26932937275251, 53.19054463402773],
            [28.258149648587562, 53.19221919955646],
            [28.249764855463752, 53.18552054263898],
            [28.24417499428074, 53.182170821626244],
            [28.228802872654455, 53.18552054263898],
            [28.220418080430193, 53.19054463402773],
            [28.207840890744592, 53.18384571450821],
            [28.198058632100185, 53.18384571450821],
            [28.191071305396463, 53.19138192533569],
            [28.191071305396463, 53.197242505837096],
            [28.18548144331413, 53.202265223961035],
            [28.170109322587223, 53.20561337565681],
            [28.160327064842193, 53.20561337565681],
            [28.139365082032953, 53.21230889394042],
            [28.119800564744367, 53.21565626052808],
            [28.112813238040474, 53.2231868793711],
            [28.123992961306215, 53.229879651125145],
            [28.121198031164283, 53.23657137786694],
            [28.108620840579476, 53.238244145650924],
            [28.101633513875754, 53.245770793087615],
            [28.096043651793195, 53.254132182254466],
            [28.094646186272655, 53.264163692500574],
            [28.10398020090514, 53.26625722722696],
            [28.095859062166937, 53.270347340178375],
            [28.0838065007473, 53.276220051826044],
            [28.072200331056763, 53.28262572585851],
            [28.06282611641967, 53.286361925865265],
            [28.051219946729134, 53.29223243738147],
            [28.041845732091872, 53.29836892821925],
            [28.033810691744293, 53.30263727079165],
            [28.024882868836357, 53.3058382484362],
            [28.01729421931975, 53.30743864700719],
            [28.009705569803145, 53.30770537409131],
            [28.002563311117513, 53.3061049855184],
            [27.99542105243188, 53.30343753756466],
            [27.99363548820969, 53.29916927498056],
            [27.994974661600907, 53.296234596684656],
            [27.994081879040664, 53.29169878823916],
            [27.990064358866732, 53.28903044038378],
            [27.98426127357243, 53.28689564220963],
            [27.98113653595891, 53.2828926084664],
            [27.981582926789883, 53.27968991146105],
            [27.98560044786194, 53.27488541537883],
            [27.98560044786194, 53.27168211831264],
            [27.97801179744704, 53.2682116085893],
            [27.96997675709929, 53.26741068180519],
            [27.963280890143153, 53.267143703055694],
            [27.95747780484868, 53.265541794476235],
            [27.957031414017706, 53.260735708116215],
            [27.958816978240066, 53.254860869327445],
            [27.955692240626547, 53.24631420911925],
            [27.951674719554262, 53.24444439928874],
            [27.946318025989285, 53.24417727715951],
            [27.942300505815524, 53.245512872206916],
            [27.938282985641706, 53.24898522414037],
            [27.932926291178262, 53.24898522414037],
            [27.923552077439297, 53.24818393671103],
            [27.919534557265536, 53.24391015336283],
            [27.92042733892748, 53.238834480649814],
            [27.925784033390926, 53.235094126176534],
            [27.931140726956073, 53.23268944010988],
            [27.939175767303652, 53.23055182780763],
            [27.943639679206683, 53.22707798011527],
            [27.939175767303652, 53.22413835051725],
            [27.928462380173528, 53.223069344511885],
            [27.909267560966327, 53.22333659838057],
            [27.866860401480096, 53.22280208897581],
            [27.86373566296828, 53.220129439733455],
            [27.86373566296828, 53.21455830696533],
            [27.86373566296828, 53.212912454120044],
            [27.864628445528524, 53.186172286712804],
            [27.874002659267433, 53.18483484029019],
            [27.9074819958459, 53.183229849740314],
            [27.944228915642498, 53.18270553973315],
            [27.96765552298166, 53.18304794692858],
            [27.988796607828874, 53.18339035139053],
            [28.002224054265582, 53.18441754837471],
            [28.01165183544316, 53.18424635058574],
            [28.02222237786674, 53.18219192381429],
            [28.024222210047128, 53.17825399689178],
            [28.02165099724374, 53.17534312328456],
            [28.01222321606616, 53.17294578440766],
            [28.00365250582314, 53.17174706500356],
            [27.997367318071895, 53.170548312108906],
            [27.996795937448894, 53.16678058443881],
            [28.003366815511527, 53.16421148990224],
            [28.010223382987476, 53.162327389497136],
            [28.01479442886972, 53.15941543473946],
            [28.01793702229611, 53.1561606638914],
            [28.01793702229611, 53.15136370914206],
            [28.013365977312162, 53.147594297161675],
            [28.00679509924953, 53.14725160698691],
            [27.998795769629453, 53.149479044242355],
            [27.99451041495695, 53.15136370914206],
            [27.986225395025315, 53.15307696859884],
            [27.979654516962682, 53.15239167301962],
            [27.973655020421347, 53.15033572065414],
            [27.96994104547366, 53.14502405419455],
            [27.969083974539103, 53.140054481070706],
            [27.971940878552346, 53.13474154296097],
            [27.97736899447068, 53.13217053083014],
            [27.98051158789724, 53.12599947348201],
            [27.981082969418537, 53.12222783529995],
            [27.97794037509385, 53.118970244992965],
            [27.97108380761796, 53.114683566549616],
            [27.964227239243712, 53.11245432430354],
            [27.95708498055808, 53.109710483539516],
            [27.950799793705187, 53.10645194469208],
            [27.943086154396553, 53.10302163763339],
            [27.93651527633392, 53.09787566353464],
            [27.93537251508809, 53.092729073842065],
            [27.93794372789148, 53.086895528036905],
            [27.942514773773723, 53.08380686040164],
            [27.945657367200113, 53.078658587921495],
            [27.946800128446057, 53.070248418531264],
            [27.946800128446057, 53.06321007606954],
            [27.949942721872446, 53.058746141327845],
            [27.957942051492466, 53.055655453460986],
            [27.963370168309325, 53.054968603946634],
            [27.969655355162047, 53.0535948720721],
            [27.971940878552346, 53.05050381468726],
            [27.973655020421347, 53.04552331175171],
            [27.976511923536293, 53.0431187252957],
            [27.980225897585683, 53.042259911911],
            [27.984796943467927, 53.04140108141701],
            [27.985368324090928, 53.03779380596336],
            [27.983654182221926, 53.03367083594094],
            [27.98051158789724, 53.02971928691585],
            [27.973655020421347, 53.02490821624497],
            [27.967084142358715, 53.01958104780044],
            [27.963370168309325, 53.015284464939725],
            [27.95937050305008, 53.0115031185793],
            [27.950799793705187, 53.01047178479416],
            [27.939943560071868, 53.00789334196634],
            [27.93051577979253, 53.0072057313414],
            [27.923944901729897, 53.005142833742354],
            [27.917945404290265, 53.00222022617413],
            [27.911660217437316, 52.99843773512731],
            [27.905375029686297, 52.99379513356746],
            [27.903089507194295, 52.98898005659419],
            [27.897761039770046, 52.98291287005861],
            [27.907928386676645, 52.98025136155616],
            [27.91596342792269, 52.977563600082306],
            [27.921766513217165, 52.97702602815741],
            [27.929355162733714, 52.97648844900374],
            [27.932033509516316, 52.97299402229987],
            [27.932926291178262, 52.96519774508903],
            [27.934711856298918, 52.95632440836209],
            [27.937390203081293, 52.9533662247689],
            [27.944532461766926, 52.951214691373366],
            [27.94899637277166, 52.94825615880052],
            [27.952567502114675, 52.94233848547918],
            [27.957031414017706, 52.93937934526008],
            [27.97176232132165, 52.93937934526008],
            [27.982029318519153, 52.94153146735732],
            [27.992742705649277, 52.944490460394434],
            [28.003009701948486, 52.94825615880052],
            [28.009259178073876, 52.951214691373366],
            [28.013723089976907, 52.95417302213116],
            [28.015062263368293, 52.95551765113538],
            [28.015955045928536, 52.95955128676519],
            [28.021758130324656, 52.96250904727776],
            [28.028453998179316, 52.963315674070714],
            [28.03336430091332, 52.96224016851619],
            [28.035596255966652, 52.95928238960926],
            [28.03336430091332, 52.95605549113924],
            [28.02890038901029, 52.95067679170671],
            [28.02890038901029, 52.94664232772976],
            [28.031132344961748, 52.94206948075009],
            [28.03291790918405, 52.937496150412755],
            [28.03291790918405, 52.93453667902304],
            [28.03157873579272, 52.92996255251859],
            [28.02979317157053, 52.92619526179817],
            [28.023990086276115, 52.920543711236746],
            [28.023990086276115, 52.91435307110771],
            [28.027561215618903, 52.90869997421987],
            [28.032471518353134, 52.90196913523641],
            [28.03916738530927, 52.896583711228914],
            [28.054791076071922, 52.89469865494749],
            [28.067736419153675, 52.893890747965486],
            [28.08202093652494, 52.89335213566653],
            [28.09809101722027, 52.89200557455257],
            [28.11282192542251, 52.88958165945104],
            [28.12799922445572, 52.88823498120104],
            [28.144515696880262, 52.88823498120104],
            [28.155675475739713, 52.888773657629656],
            [28.165049690376918, 52.88958165945104],
            [28.174423904115883, 52.89065897160464],
            [28.179780598579157, 52.89281351613249],
            [28.18870842148715, 52.894967953567175],
            [28.20076098200849, 52.89577583992764],
            [28.205671284742493, 52.89281351613249],
            [28.207903240694122, 52.88904299306273],
            [28.21236715259721, 52.88608020909203],
            [28.221294975505145, 52.88473342206919],
            [28.228437233292482, 52.88581085525129],
            [28.236472274538357, 52.887965640747666],
            [28.24540009744635, 52.88688826111593],
            [28.250756791011497, 52.878807063117506],
            [28.251203182740767, 52.86829925337679],
            [28.25477431208361, 52.86290964506264],
            [28.2556670937455, 52.858327952012075],
            [28.258345440528103, 52.85347622051711],
            [28.265041308382763, 52.85212842089038],
            [28.27352274045961, 52.85212842089038],
            [28.28289695419852, 52.85509352461082],
            [28.289592821154883, 52.85751936775972],
            [28.299859818352388, 52.86021459037602],
            [28.311019596313486, 52.861562138913655],
            [28.317715464168145, 52.862101146177906],
            [28.325750504515725, 52.86290964506264],
            [28.33333915403233, 52.861562138913655],
            [28.339142239326748, 52.85671076844227],
            [28.342713368669592, 52.85078057941354],
            [28.34360615033154, 52.843231894377766],
            [28.338695848495774, 52.83918741625217],
            [28.336463892544202, 52.83271546771135],
            [28.334678327423717, 52.82516364180685],
            [28.33333915403233, 52.81707094283968],
            [28.334678327423717, 52.81248441123131],
            [28.34003502188699, 52.80897673675082],
            [28.35119480074644, 52.80654818118052],
            [28.359229841093963, 52.80465921047801],
            [28.373960749296373, 52.80250028710651],
            [28.3873524832091, 52.801150905160796],
            [28.395387524454975, 52.79926169998453],
            [28.409672040927944, 52.797102508095065],
            [28.418153473004963, 52.79602287222423],
            [28.432884381207202, 52.79305373471874],
            [28.45698950314835, 52.79008439454162],
            [28.459354277007606, 52.789954388220906],
            [28.460782144580378, 52.791825432198095],
            [28.466372006662937, 52.81463620889406],
            [28.46497454024302, 52.831525367202005],
            [28.448204954894777, 52.83827919303042],
            [28.42165311090247, 52.848407962257625],
            [28.42165311090247, 52.85515916206572],
            [28.43842269625054, 52.860221873041155],
            [28.45239735145674, 52.866127622891554],
            [28.469166937704188, 52.87456301367229],
            [28.48453905753155, 52.88046681199381],
            [28.48593652305209, 52.89058573814145],
            [28.48453905753155, 52.90660254237349],
            [28.478949195449047, 52.9158727225481],
            [28.4677694712841, 52.922613426368684],
            [28.466372006662937, 52.93103783013186],
            [28.45938467816046, 52.94114495177814],
            [28.448204954894777, 52.94872374280652],
            [28.45239735145674, 52.9537755333144],
            [28.457987213539127, 52.96387734356472],
            [28.4677694712841, 52.96724408964309],
            [28.481744126490298, 52.97650128810403],
            [28.494321316175956, 52.981549832958535],
            [28.509693436003317, 52.98407388460214],
            [28.52227062568892, 52.980708449735175],
            [28.532052884333268, 52.97229371638207],
            [28.540437676557588, 52.971452152395045],
            [28.550219936101314, 52.971452152395045],
            [28.56279712488754, 52.977342753165544],
            [28.568386986969927, 52.98575650355991],
            [28.575374314573025, 52.989962764969675],
            [28.568386986969927, 53.000056119794124],
            [28.55441233176373, 53.00173811642111],
            [28.553014867142565, 53.01098792605205],
            [28.553014867142565, 53.01939512308661],
            [28.540437676557588, 53.02359810826624],
            [28.530655418812557, 53.036204605957835],
            [28.530655418812557, 53.04628715003213],
            [28.53764274551645, 53.05216754619539],
            [28.54323260759884, 53.05888701522372],
            [28.544630074018755, 53.06728487909396],
            [28.540437676557588, 53.07736015484738],
            [28.529257953292017, 53.082396908690555],
            [28.530655418812557, 53.08743307257822],
            [28.539040211936367, 53.097503634085626],
            [28.53960073931006, 53.099859475256835],
          ],
        ],
      },
      properties: {
        shapeName: "Staryya Darohi",
        shapeISO: "",
        shapeID: "67162791B98065545782790",
        shapeGroup: "BLR",
        shapeType: "ADM2",
      },
    },
  ],
};
